/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './blood-bank-adverse-event.reducer';

export const BloodBankAdverseEvent = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const bloodBankAdverseEventList = useAppSelector(state => state.bloodBankAdverseEvent.entities);
  const loading = useAppSelector(state => state.bloodBankAdverseEvent.loading);
  const totalItems = useAppSelector(state => state.bloodBankAdverseEvent.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="blood-bank-adverse-event-heading" data-cy="BloodBankAdverseEventHeading">
        <Translate contentKey="tinyMedicRestApp.bloodBankAdverseEvent.home.title">Blood Bank Adverse Events</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.bloodBankAdverseEvent.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/blood-bank-adverse-event/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.bloodBankAdverseEvent.home.createLabel">Create new Blood Bank Adverse Event</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.bloodBankAdverseEvent.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {bloodBankAdverseEventList && bloodBankAdverseEventList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankAdverseEvent.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('reactionDate')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankAdverseEvent.reactionDate">Reaction Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('reactionDate')} />
                </th>
                <th className="hand" onClick={sort('reactionType')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankAdverseEvent.reactionType">Reaction Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('reactionType')} />
                </th>
                <th className="hand" onClick={sort('reactionDescription')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankAdverseEvent.reactionDescription">Reaction Description</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('reactionDescription')} />
                </th>
                <th className="hand" onClick={sort('severity')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankAdverseEvent.severity">Severity</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('severity')} />
                </th>
                <th className="hand" onClick={sort('reportedTo')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankAdverseEvent.reportedTo">Reported To</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('reportedTo')} />
                </th>
                <th className="hand" onClick={sort('actionTaken')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankAdverseEvent.actionTaken">Action Taken</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('actionTaken')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankAdverseEvent.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankAdverseEvent.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankAdverseEvent.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankAdverseEvent.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.bloodBankAdverseEvent.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.bloodBankAdverseEvent.inventory">Inventory</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.bloodBankAdverseEvent.bank">Bank</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {bloodBankAdverseEventList.map((bloodBankAdverseEvent, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/blood-bank-adverse-event/${bloodBankAdverseEvent.id}`} color="link" size="sm">
                      {bloodBankAdverseEvent.id}
                    </Button>
                  </td>
                  <td>{bloodBankAdverseEvent.reactionDate}</td>
                  <td>{bloodBankAdverseEvent.reactionType}</td>
                  <td>{bloodBankAdverseEvent.reactionDescription}</td>
                  <td>{bloodBankAdverseEvent.severity}</td>
                  <td>{bloodBankAdverseEvent.reportedTo}</td>
                  <td>{bloodBankAdverseEvent.actionTaken}</td>
                  <td>{bloodBankAdverseEvent.active ? 'true' : 'false'}</td>
                  <td>{bloodBankAdverseEvent.cursor}</td>
                  <td>{bloodBankAdverseEvent.lastUpdated}</td>
                  <td>{bloodBankAdverseEvent.microSec}</td>
                  <td>{bloodBankAdverseEvent.timestampEntry}</td>
                  <td>
                    {bloodBankAdverseEvent.inventory ? (
                      <Link to={`/blood-bank-inventory/${bloodBankAdverseEvent.inventory.id}`}>{bloodBankAdverseEvent.inventory.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {bloodBankAdverseEvent.bank ? (
                      <Link to={`/blood-bank/${bloodBankAdverseEvent.bank.id}`}>{bloodBankAdverseEvent.bank.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/blood-bank-adverse-event/${bloodBankAdverseEvent.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/blood-bank-adverse-event/${bloodBankAdverseEvent.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/blood-bank-adverse-event/${bloodBankAdverseEvent.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.bloodBankAdverseEvent.home.notFound">No Blood Bank Adverse Events found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={bloodBankAdverseEventList && bloodBankAdverseEventList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default BloodBankAdverseEvent;
